import { format, isValid, parseISO, Locale } from "date-fns";
import type { Language } from "../language/language";
import { dateFns_getLocaleFromLanguage } from "./distanceToNow";

export const formatOrDefault = (date: Date | string | null, formatPattern: string, defaultResult: string, language?: Language): string => {
    if (date == null) return defaultResult;
    let inputDate: Date;
    if (typeof date === "string") {
        inputDate = parseISO(date);
    } else inputDate = date;

    if (!isValid(inputDate)) return defaultResult;

    const locale: Locale | undefined = language ? dateFns_getLocaleFromLanguage(language) : undefined;

    try {
        if (locale) return format(inputDate, formatPattern, { locale: locale });

        return format(inputDate, formatPattern);
    } catch (e) {
        console.error(`Could not format string '${inputDate}' with pattern '${formatPattern}': ${e.message}`, e);
        return defaultResult;
    }
};
